export const NotificationJobStatus = Object.freeze({
    QUEUED: {
        key: 'QUEUED',
        translationKey: 'notificationJob.queued',
        statusColor: 'default'
    },
    RUNNING: {
        key: 'RUNNING',
        translationKey: 'notificationJob.running',
        statusColor: 'info'
    },
    DONE: {
        key: 'DONE',
        translationKey: 'notificationJob.done',
        statusColor: 'success'
    },
    PARTIALLY_FAILED: {
        key: 'PARTIALLY_FAILED',
        translationKey: 'notificationJob.partially_failed',
        statusColor: 'warning'
    },
    FAILED: {
        key: 'FAILED',
        translationKey: 'notificationJob.failed',
        statusColor: 'error'
    }
});


export function isTerminalState(jobStatus) {
    return [
        NotificationJobStatus.DONE.key,
        NotificationJobStatus.PARTIALLY_FAILED.key,
        NotificationJobStatus.FAILED.key
    ].includes(jobStatus.toUpperCase());
}